import { render, staticRenderFns } from "./TalentsSection.vue?vue&type=template&id=ca89c2c2&scoped=true"
import script from "./TalentsSection.vue?vue&type=script&lang=js"
export * from "./TalentsSection.vue?vue&type=script&lang=js"
import style0 from "./TalentsSection.vue?vue&type=style&index=0&id=ca89c2c2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca89c2c2",
  null
  
)

export default component.exports